// @flow

// Libs
import _omit from 'lodash/omit'

// Decoders
import { createDecoder } from 'fc-decoders'
import encoder from './encoder'

// Constants
import {
  PROP_SHAPE,
} from 'fc-model-assets'

// Exports
export default function (asset: Object): Object {
  if (asset[PROP_SHAPE]) {
    return createDecoder(encoder)(asset)
  }

  return createDecoder(_omit(encoder, PROP_SHAPE))(asset)
}
